export default {
    setInitStoreUser(state, user_data){

        //remap wishlist data
        if(user_data.wish_list) {
            let wish_list = user_data.wish_list.map(item => {
                console.log('wishlist item:',item)
                let product = {
                    sku: item.sku_code,
                    sku_code: item.sku_code,
                    title: item.product.title,
                    slug: item.product.slug,
                    image: ((obj) => {
                        let img = obj.product.product_images.filter(i => {
                            return i.colour_id == obj.colour_id
                        }).sort((a, b) => {
                            return a.is_primary == true ? -1 : 1
                        })

                        if (img.length > 0) {
                            return img[0].cloudinary_url
                        } else {
                            return obj.product.product_images[0].cloudinary_url
                        }

                    })(item),
                    modifiers:{
                        Size: item.size.title,
                        Colour: item.colour.title,
                    },
                    quantity: 1,
                    soh: parseInt(item.soh),
                    price: item.price
        
                }
                return product
            })

            user_data.wish_list = wish_list
        }
        
        state.user = user_data;
    },
    setInitStoreColorPalette(state, color_palette_data){
        state.color_palette = color_palette_data;
    },
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/mutations/storesMutations.js